import { filterOrganizationIdsUserCanManageMembers } from '../../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LanIcon from '@mui/icons-material/Lan';
import { Box, Divider, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { getYearsIntervalText } from '../../utils/getYearsIntervalText';
export const BadgeListItemAnalytics = ({ badge }) => {
    const { t } = useBadgingTranslation();
    const userState = useUserState();
    const isScreenExtraSmall = useMediaQuery((theme) => theme.breakpoints.between('xs', 'sm'));
    const isScreenMediumUp = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    return (React.createElement(Box, { sx: {
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            width: '100%',
            p: 1,
            backgroundColor: themeColors.surface.secondary,
            gap: 1,
        } },
        React.createElement(Box, { sx: {
                width: '100%',
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                gap: 1,
            } },
            React.createElement(Box, { sx: {
                    width: '100%',
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center',
                    justifyContent: 'center',
                } },
                React.createElement(CheckCircleIcon, { color: badge.validAccountBadgesCount > 0 ? 'success' : 'disabled' }),
                React.createElement(Typography, { variant: 'body2', align: 'center' }, t('badges.badgeList.analytics.validBadges', { count: badge.validAccountBadgesCount }))),
            React.createElement(Divider, { orientation: isScreenExtraSmall ? 'horizontal' : 'vertical', flexItem: true, variant: isScreenExtraSmall ? 'middle' : 'fullWidth' }),
            React.createElement(Box, { sx: {
                    width: '100%',
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center',
                    justifyContent: 'center',
                } },
                React.createElement(CancelIcon, { color: 'error' }),
                React.createElement(Typography, { variant: 'body2', align: 'center' }, t('badges.badgeList.analytics.invalidBadges', { count: badge.invalidAccountBadgesCount })))),
        (isScreenExtraSmall || isScreenMediumUp) && (React.createElement(Divider, { orientation: isScreenExtraSmall ? 'horizontal' : 'vertical', flexItem: true, variant: isScreenExtraSmall ? 'middle' : 'fullWidth' })),
        React.createElement(Box, { sx: {
                width: '100%',
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                gap: 1,
            } },
            React.createElement(Box, { sx: {
                    width: '100%',
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center',
                    justifyContent: 'center',
                } },
                React.createElement(LanIcon, { color: 'disabled' }),
                React.createElement(Typography, { variant: 'body2', align: 'center' }, t('badges.badgeList.analytics.assignedOrganizations', {
                    count: filterOrganizationIdsUserCanManageMembers(userState, badge.organizationIds).length,
                }))),
            React.createElement(Divider, { orientation: isScreenExtraSmall ? 'horizontal' : 'vertical', flexItem: true, variant: isScreenExtraSmall ? 'middle' : 'fullWidth' }),
            React.createElement(Box, { sx: {
                    width: '100%',
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center',
                    justifyContent: 'center',
                } },
                React.createElement(CalendarMonthIcon, { color: 'disabled' }),
                React.createElement(Typography, { variant: 'body2', align: 'center' }, getYearsIntervalText(t, badge.expirationIntervalMonths))))));
};
